import script from "./ChallengeCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChallengeCard.vue?vue&type=script&setup=true&lang=ts"

import "./ChallengeCard.vue?vue&type=style&index=0&id=22003a0a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22003a0a"]])

export default __exports__